import React, { useState } from "react";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // 清除该字段的错误信息
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // 验证邮箱格式
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // 验证所有字段并返回错误信息
  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.subject) {
      newErrors.subject = "Please select a subject";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 验证表单
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      // 滚动到第一个错误字段
      const firstErrorField = Object.keys(formErrors)[0];
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    // 模拟表单提交
    setTimeout(() => {
      setShowSuccess(true);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        message: "",
      });
      setIsSubmitting(false);

      // 滚动到顶部显示成功消息
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // 5秒后隐藏成功消息
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }, 1000);
  };

  return (
    <main className="_main_guvbo_9 contact-page">
      <section
        className="ds-container p-m tablet:p-m flex flex-col justify-start tablet:justify-start"
        data-section-type="section:text"
      >
        <div className="flex justify-start tablet:justify-start">
          <div className="flex flex-col items-start text-left w-full">
            <div className="relative flex flex-col gap-2 w-full">
              <p className="type-title-l tablet:type-title-l">CONTACT US</p>

              <p className="type-body-s tablet:type-body-s">
                We offer several ways to get support, depending on your needs
                and the time of day. Our goal is to make sure you can always
                reach us 24/7.
              </p>

              <div className="contact-grid">
                <div className="contact-info">
                  <p className="type-title-m tablet:type-title-m">
                    CHAT SUPPORT (24/7)
                  </p>
                  <p className="type-body-s tablet:type-body-s">
                    You can contact us at any time through our virtual assistant
                    available via the chat icon at the bottom-right corner of
                    the screen.
                    <br />
                    <br />
                    If your question requires help from a human agent, the
                    chatbot will either connect you with one of our agents
                    (during opening hours) or help you create a support ticket
                    when our team is offline.
                  </p>

                  <p className="type-title-s tablet:type-title-s">
                    Our agents' opening hours are:
                  </p>
                  <ul className="list-disc space-y-[0.25em] pl-[1.5em]">
                    <li>
                      <p className="type-body-s tablet:type-body-s">
                        Monday: 10:00 - 17:00
                      </p>
                    </li>
                    <li>
                      <p className="type-body-s tablet:type-body-s">
                        Tuesday: 10:00 - 14:00
                      </p>
                    </li>
                    <li>
                      <p className="type-body-s tablet:type-body-s">
                        Wednesday - Saturday: 10:00 - 17:00
                      </p>
                    </li>
                  </ul>

                  <p className="type-title-m tablet:type-title-m">
                    Need assistance with a store purchase?
                  </p>
                  <p className="type-body-s tablet:type-body-s">
                    If you require help with something purchased in one of our
                    physical stores, please contact the store directly. Our
                    online customer service team is unable to assist with
                    in-store purchases.
                  </p>

                  <p className="type-title-m tablet:type-title-m">
                    Have a question unrelated to online orders?
                  </p>
                  <p className="type-body-s tablet:type-body-s">
                    Our online customer service cannot assist with inquiries
                    unrelated to online orders or our website. For all other
                    inquiries, please contact the relevant department.
                  </p>
                </div>

                <div className="contact-form-container">
                  <p className="type-title-m tablet:type-title-m">WEBFORM</p>
                  <p className="type-body-s tablet:type-body-s mb-4">
                    If you would like to reach us outside of our live chat
                    hours, you can contact us via our webform, and we will get
                    back to you via email as soon as possible.
                  </p>

                  {showSuccess && (
                    <div className="success-message">
                      Your message has been sent successfully. We will get back
                      to you soon!
                    </div>
                  )}

                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group-row">
                      <div className="form-group">
                        <label htmlFor="firstName">First Name *</label>
                        <input
                          type="text"
                          id="firstName"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          className={errors.firstName ? "error" : ""}
                        />
                        {errors.firstName && (
                          <span className="error-text">{errors.firstName}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="lastName">Last Name *</label>
                        <input
                          type="text"
                          id="lastName"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          className={errors.lastName ? "error" : ""}
                        />
                        {errors.lastName && (
                          <span className="error-text">{errors.lastName}</span>
                        )}
                      </div>
                    </div>

                    <div className="form-group-row">
                      <div className="form-group">
                        <label htmlFor="email">Email *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          className={errors.email ? "error" : ""}
                        />
                        {errors.email && (
                          <span className="error-text">{errors.email}</span>
                        )}
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Subject *</label>
                      <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        className={errors.subject ? "error" : ""}
                      >
                        <option value="">Select a subject</option>
                        <option value="order">Order Inquiry</option>
                        <option value="return">Return & Refund</option>
                        <option value="product">Product Information</option>
                        <option value="other">Other</option>
                      </select>
                      {errors.subject && (
                        <span className="error-text">{errors.subject}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        rows="5"
                        value={formData.message}
                        onChange={handleInputChange}
                        className={errors.message ? "error" : ""}
                      ></textarea>
                      {errors.message && (
                        <span className="error-text">{errors.message}</span>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Sending..." : "SEND MESSAGE"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
